import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=d0acedd8&scoped=true&"
import script from "./UploadFiles.vue?vue&type=script&lang=js&"
export * from "./UploadFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploadFiles.vue?vue&type=style&index=0&id=d0acedd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0acedd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0acedd8')) {
      api.createRecord('d0acedd8', component.options)
    } else {
      api.reload('d0acedd8', component.options)
    }
    module.hot.accept("./UploadFiles.vue?vue&type=template&id=d0acedd8&scoped=true&", function () {
      api.rerender('d0acedd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadFile/UploadFiles.vue"
export default component.exports